<script>
import axios from '@/utils/axios';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { documentTemplates } from '@/utils/document-template';
import { byDocumentType, createOrUpdate } from '@/utils/document-setting';
import DocumentPlaceholder from '@/components/common/quotation-placeholder.vue';

export default {
 components:{
  DocumentPlaceholder
 },
 inject: ['setLoading'], 
  data() {
   return {
    errors: {},
    editorConfig: {},
    title: "Settings",
    text: "Administration",
    text1: "Settings",
    editor: ClassicEditor,
    type: "quotation",
    send_on_sms: false,
    send_on_email: false,
    send_on_whatsapp: false,
    send_with_pdf: false,
    auto_send: false,
    terms: '',
    submitTimeout: null,
    mail_subject: "Quotation from {entity_name}",
    mail_body: "Dear {client_name}, <br> Please find the details of the quotation {quotation_subject} below. Explore the quotation and accept if you find it perfect for you.",
    mail_footer: "<b>Questions about the Quotation?</b> <br>If you need to modify the quotation or have questions about the details in the quotation, please reach out to the sender by emailing them directly.<b> <br><br>Do Not Share This Email</b> <br>This email contains a secure link to your quotation. Please do not share this email, link, or access code with others. <br><br>Thank You, <br>{sender_name}, <br>M:{sender_mobile}",
    templates: [],
    template: null,
    document_template_id: null,
   };
 },

 async mounted(){
  await this.byType(this.type);
  this.allDocumentTemplates();
 },

 methods: {

  selectTemplate(row) {
   this.template = row;
   // Debounce to prevent rapid-fire submits
   clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
     this.submitForm();
   }, 50); // 50ms debounce
  },

  async allDocumentTemplates(){
   try{
    const response = await documentTemplates(this.type);
    this.templates = response.data.data;
    this.template = this.templates.find(t => t.id === this.document_template_id);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    const data = response.data.data;
    this.populateData(data);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  populateData(data){
   if(data != null){
    this.terms = data.terms || '';
    this.send_on_sms = data.send_on_sms;
    this.send_on_email = data.send_on_email;
    this.send_on_whatsapp = data.send_on_whatsapp;
    this.send_with_pdf = data.send_with_pdf;
    this.auto_send = data.auto_send;
    this.mail_subject = data.mail_subject;
    this.mail_body = data.mail_body;
    this.mail_footer = data.mail_footer; 
    this.document_template_id = data.document_template_id;
   }
  },

  async submitForm(){
   this.errors = {};
   this.setLoading(true);
   try{
    const payload = {
     type: this.type,
     terms: this.terms || '',
     send_on_sms: this.send_on_sms,
     send_on_email: this.send_on_email,
     send_on_whatsapp: this.send_on_whatsapp,
     send_with_pdf: this.send_with_pdf,
     auto_send: this.auto_send,
     mail_subject: this.mail_subject,
     mail_body: this.mail_body,
     mail_footer: this.mail_footer,
     document_template_id: this.template?.id || null  
    };
    const response = await createOrUpdate(payload);
     const data = response.data.data;
     this.populateData(data);

    this.$swalToast(response.data.message);
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error');
    }    
   }finally{
    this.setLoading(false);
   }
  },

 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="head-icons ms-2">
 
</div>
</div>
<!-- /Breadcrumb -->

<settings-tab></settings-tab>
<div class="row">
<document-sidebar></document-sidebar>
<div class="col-xl-9">
<div class="card">
<div class="card-body">
<div class="border-bottom mb-3 pb-3">
  <h4>Quotation Settings</h4>
</div>
<form @submit.prevent="submitForm" enctype="multipart/form-data">
  <div class="border-bottom mb-3">
  <div class="row">
   <div class="col-md-12">
    <!-- <div>
        <h6 class="mb-3">Banking Information</h6>
    </div> -->
   </div>
  </div>

  <div class="row">
   <div class="col-md-8">

    <div class="card">
     <div class="card-header"><h5>Email Settings</h5></div>
     <div class="card-body">

      <div class="mb-3">
       <DocumentPlaceholder/> 
      </div>  

      <div class="mb-3">
        <label class="form-label">Email Subject</label>
        <input type="text" class="form-control" v-model="mail_subject" />
       <div class="text-danger small mt-1" v-if="errors.mail_subject">{{ errors.mail_subject[0] }}</div>
      </div>  
      
      <div class="mb-3">
        <label class="form-label">Email Body</label>
       <ckeditor :editor="editor" v-model="mail_body" :config="editorConfig"></ckeditor>
       <div class="text-danger small mt-1" v-if="errors.mail_body">{{ errors.mail_body[0] }}</div>
      </div>

      <div class="mb-3">
        <label class="form-label">Email Footer</label>
       <ckeditor :editor="editor" v-model="mail_footer" :config="editorConfig"></ckeditor>
       <div class="text-danger small mt-1" v-if="errors.mail_footer">{{ errors.mail_footer[0] }}</div>
      </div>

     </div> 
    </div>

    <div class="card">
     <div class="card-header"><h5>Terms</h5></div>
     <div class="card-body">
     <div class="mb-3">
      <ckeditor :editor="editor" :config="editorConfig" v-model="terms"></ckeditor>
      <div class="text-danger small mt-1" v-if="errors.terms">{{ errors.terms[0] }}</div> 
     </div>
     </div> 
    </div>

   </div>
   <div class="col-md-4">
    
    <div class="card">
     <div class="card-header"><h5>Other Settings</h5></div>
     <div class="card-body">
      
     <div class="form-check form-switch d-flex mb-2">
     <label for="send_on_sms" class="form-check-label me-2">Send on SMS</label>
     <input class="form-check-input m-0" type="checkbox" id="send_on_sms" v-model="send_on_sms" @change="submitForm">
     </div>

     <div class="form-check form-switch d-flex mb-2">
     <label for="send_on_email" class="form-check-label me-2">Send on Email</label>
     <input class="form-check-input m-0" type="checkbox" id="send_on_email" v-model="send_on_email" @change="submitForm">
     </div>

     <div class="form-check form-switch d-flex mb-2">
     <label for="send_on_whatsapp" class="form-check-label me-2">Send on WhatsApp</label>
     <input class="form-check-input m-0" type="checkbox" id="send_on_whatsapp" v-model="send_on_whatsapp" @change="submitForm">
     </div>

     <div class="form-check form-switch d-flex mb-2">
     <label for="send_with_pdf" class="form-check-label me-2">Send with PDF</label>
     <input class="form-check-input m-0" type="checkbox" id="send_with_pdf" v-model="send_with_pdf" @change="submitForm">
     </div>

    <hr>    

    <div class="mt-3">
    <label class="form-label">Templates</label>
    <div class="row g-3 mt-2">
    <div v-for="row in templates" :key="row.id" class="col-md-12" @click="selectTemplate(row)" :class="{ 'template-selected': template?.id === row.id }">
    <div class="template-card border rounded p-3 h-100 d-flex flex-column position-relative cursor-pointer">
    <div class="position-absolute top-0 end-0 p-2">
     <input type="radio" :id="`template-${row.id}`" :name="`template-${type}`" v-model="template" :value="row" class="form-check-input">
    </div>
    
  <div class="template-image mb-3 flex-grow-1 d-flex align-items-center justify-content-center">
  <img :src="row.document_url" :alt="row.name" class="img-fluid rounded shadow-sm" 
    v-if="row.document_url"
    @error="$event.target.style.display='none'; $event.target.nextElementSibling.style.display='flex'">
  <div class="bg-light rounded p-4 text-center text-muted gap-3" 
    :style="row.document_url ? 'display:none' : ''">
    <i class="fas fa-image fs-1 opacity-50"></i>
    <div class="mt-2">{{ row.name }}</div>
  </div>
</div>
     <div class="text-center fw-bold text-truncate" style="font-size: 0.95rem;"> {{ row.name }} </div>
    </div>
    </div>

   </div>
    <div class="text-danger small mt-2" v-if="errors.document_template_id"> {{ errors.document_template_id[0] }} </div>
    </div>

     </div> 
    </div>

   </div>
  </div>  

  </div>

  <div class="d-flex align-items-center justify-content-end">
   <!-- <button type="button" class="btn btn-outline-light border me-3"> Cancel </button> -->
   <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
</div>
</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->
</template>